import { usePromotion } from '@mc/promo-utils'
import { useGiftEnabled } from '../../../lib/helpers'

export const useGiftingOnMobileNav = () => {
  const { giftEnabled } = useGiftEnabled()
  const { isPromotionOn } = usePromotion()

  return giftEnabled && isPromotionOn
}
